<script setup>


</script>

<template>
   <h1> Pagina no encontrada</h1>
</template>

<style scoped>

</style>
